var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_925_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4104 10.7875L20.4678 9.77853L17.3643 3.48673C17.2795 3.31446 17.14 3.17501 16.9678 3.09024C16.5357 2.87696 16.0107 3.0547 15.7947 3.48673L12.6912 9.77853L5.74863 10.7875C5.55722 10.8149 5.38222 10.9051 5.24824 11.0418C5.08626 11.2083 4.997 11.4323 5.00008 11.6645C5.00315 11.8968 5.09831 12.1183 5.26464 12.2805L10.2877 17.1777L9.10097 24.093C9.07315 24.2538 9.09095 24.4193 9.15236 24.5706C9.21377 24.7218 9.31634 24.8528 9.44843 24.9488C9.58052 25.0447 9.73685 25.1017 9.89968 25.1133C10.0625 25.1249 10.2254 25.0907 10.3697 25.0145L16.5795 21.7496L22.7893 25.0145C22.9588 25.1047 23.1557 25.1348 23.3443 25.102C23.8201 25.0199 24.14 24.5688 24.058 24.093L22.8713 17.1777L27.8943 12.2805C28.0311 12.1465 28.1213 11.9715 28.1486 11.7801C28.2225 11.3016 27.8889 10.8586 27.4104 10.7875Z",
    fill: "#383838"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_925_24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.1ba7af0cbc0cd07596902b40616eea32.svg";
export { ForwardRef as ReactComponent };